import { ref, watch } from "vue";

export function useStorage(key, defaultValue) {
    let storedValue = read()

    let stored = ref(storedValue || defaultValue || []);

    watch(stored, write, { deep: true });

    function read() {
        return JSON.parse(localStorage.getItem(key));
    }

    function write() {
        localStorage.setItem(key, JSON.stringify(stored.value));
    }

    return stored.value;
}
